export default {
  computed: {
    platformId() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        return 2;
      }

      if (/ipad|iphone|ipod|ios/i.test(userAgent) && !window.MSStream) {
        return 3;
      }

      console.warn('PROBLEM: default platformId');
      return 1;
    }
  }
};
